import {ImageholderVariants} from './enums';
import ImageHolder from './variants/Image';
import ImageHolderWithLink from './variants/ImageWithLink';

import type {Props} from './types';

let ComponentMap: {[key: string]: any} = {};
ComponentMap[ImageholderVariants.WITHLINK] = ImageHolderWithLink;
ComponentMap[ImageholderVariants.DEFAULT] = ImageHolder;

const Component = (props: Props) => {
  const {variant, ...prop} = props;
  const MappedComponent = variant.trim().length
    ? ComponentMap[variant]
    : ComponentMap[ImageholderVariants.DEFAULT];
  if (MappedComponent) return <MappedComponent {...prop} />;
  else return <></>;
};

export default Component;
